import View from './view';
export const CheckmarkText = View;
